import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

// Delete this as part of berry-4386-add-helpcenterid-to-routes FG clean up
export const helpCenterSettingsEmailOldRoute: InvariantRoute = {
	name: 'helpcenter-settings-email-old',
	path: '/jira/helpcenter/projects/:projectKey/settings/email',
	exact: true,
};
